<template>
  <b-overlay
    :show="busy"
    spinner-type="grow"
    spinner-variant="primary"
    rounded="sm"
  >
    <!-- {{ search.selected }}<br /> -->
    <!-- {{ item }} -->
    <b-card class="border-none py-0 mb-0 no-margin px-1">
      <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="text-primary mr-1"></i>
        {{ item.confirmationno }}
        <span class="text-warning"
          >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
        >
      </b-card-header>
      <b-card-body class="py-0">
        <b-row>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              :label="$helpers.requiredlabel(requirement, 'Driver')"
              :class="
                $helpers.requiredlabel(requirement, 'Driver').slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-for="driver"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.driver"
                  placeholder="Enter driver"
                  size="sm"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.driver = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label-cols="12"
              :label="$helpers.requiredlabel(requirement, 'Client SL A/C')"
              :class="
                $helpers
                  .requiredlabel(requirement, 'Client SL A/C')
                  .slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-size="sm"
            >
              <treeselect
                placeholder="Select slac..."
                searchPromptText="Type at least 3 chars..."
                v-model="item.slac"
                :clearable="true"
                :async="true"
                :load-options="treeselect_loadSLAC"
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
                :disabled="readonly"
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label-cols="12"
              :label="$helpers.requiredlabel(requirement, 'Event')"
              :class="
                $helpers.requiredlabel(requirement, 'Event').slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-size="sm"
            >
              <treeselect
                placeholder="Select event..."
                searchPromptText="Type at least 4 chars..."
                v-model="item.eventcode"
                :clearable="true"
                :async="true"
                :load-options="treeselect_loadEvent"
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              :label="$helpers.requiredlabel(requirement, 'Your Ref / PO')"
              :class="
                $helpers
                  .requiredlabel(requirement, 'Your Ref / PO')
                  .slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-for="yourref"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.yourref"
                  placeholder="Enter Your Ref / PO"
                  size="sm"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.yourref = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <span>Invoice Items</span>
        <b-row class="dragabbleinvoiceitems mt-1 cars" no-gutters>
          <b-col cols="auto">
            <b-btn size="sm" disabled variant="primary" @click="addItemline()"
              ><i class="fa fa-plus"></i
            ></b-btn>
          </b-col>
          <b-col class="ml-2">
            <!-- <draggable
              tag="ul"
              :list="item.items"
              class="list-group"
              handle=".handle"
            > -->
            <li
              class="list-group-item py-1"
              v-for="(lineitem, idx) in item.items"
              :key="idx"
            >
              <!-- {{ lineitem }} -->
              <b-row no-gutters>
                <b-col cols="2" class="pt-2">
                  <b-link>
                    <i class="fa fa-bars fa-2x text-primary handle"></i>
                  </b-link>
                  <div class="text inline mx-2">{{ idx + 1 }}.</div>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col cols="9" class="text-left">
                      <b-form-group
                        class="mb-0"
                        label=""
                        label-for="ref"
                        label-cols="12"
                      >
                        <b-form-input
                          :id="'lineitem_ref_' + idx"
                          v-model="lineitem.ref"
                          placeholder="Ref"
                          class="text-left"
                        ></b-form-input>
                      </b-form-group>
                      <b-tooltip
                        :target="'lineitem_ref_' + idx"
                        triggers="hover"
                        >Enter/change line item reference</b-tooltip
                      >
                    </b-col>
                    <b-col class="text-right pt-1">
                      <b-form-input
                        :id="'lineitem_slprice_' + idx"
                        size="sm"
                        v-model="lineitem.cost"
                        lazy-formatter
                        :formatter="nocomma"
                        placeholder="Price"
                      ></b-form-input>
                      <b-tooltip
                        :target="'lineitem_slprice_' + idx"
                        triggers="hover"
                        >Enter price to client</b-tooltip
                      >
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="1" class="text-right pt-2">
                  <b-link @click="removeAt(idx)">
                    <i class="fa fa-times fa-2x text-danger ml-3"></i> </b-link
                ></b-col>
              </b-row>
            </li>
            <!-- </draggable> -->
          </b-col>
        </b-row>
        <b-row align-v="end" class="my-4">
          <b-col></b-col>
          <b-col cols="5" class="text-right px-4">
            <b-row no-gutters>
              <b-col
                ><span class="h5 mr-5 text-primary">Total: </span><br
              /></b-col>
              <b-col
                ><span id="saletotal" class="h5 text-right text-primary pr-2">{{
                  total | currency("")
                }}</span></b-col
              >
            </b-row>
            <b-tooltip target="saletotal" triggers="hover"
              >Total price to charge client</b-tooltip
            >
          </b-col>
          <b-col cols="1" class="text-right"> </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" sm="12">
            <b-form-group
              label="Description as shown on Invoice"
              label-for="description"
              label-cols="12"
            >
              <b-form-textarea
                id="description"
                v-model="item.description"
                placeholder="Details"
                rows="5"
                max-rows="7"
                class="smalltextarea"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" sm="12">
            <b-form-group
              label="Voucher Notes"
              label-for="message"
              label-cols="12"
            >
              <b-form-textarea
                id="message"
                v-model="item.message"
                placeholder="Voucher Notes"
                :disabled="readonly"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label-cols="12"
              :label="$helpers.requiredlabel(requirement, 'Supplier BL A/C')"
              :class="
                $helpers
                  .requiredlabel(requirement, 'Supplier BL A/C')
                  .slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-size="sm"
            >
              <treeselect
                placeholder="Select blac..."
                searchPromptText="Type at least 3 chars..."
                v-model="item.blac"
                :clearable="true"
                :async="true"
                :load-options="treeselect_loadBLAC"
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
                :disabled="readonly"
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              :label="$helpers.requiredlabel(requirement, 'BL Invoice No')"
              :class="
                $helpers
                  .requiredlabel(requirement, 'BL Invoice No')
                  .slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-for="blinvoiceno"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.blinvoiceno"
                  placeholder="Enter BL invoice no"
                  size="sm"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.blinvoiceno = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label="BL Invoice Date"
              label-for="blinvoicedate"
              label-cols="12"
            >
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-datepicker
                    size="sm"
                    v-model="item.blinvoicedate"
                    button-only
                    label-help=""
                    locale="en-GB"
                    hide-header
                    :disabled="readonly"
                  ></b-form-datepicker>
                </b-input-group-prepend>
                <b-form-input
                  size="sm"
                  id="date"
                  v-model="item.blinvoicedate"
                  type="text"
                  placeholder="YYYY-MM-DD"
                  autocomplete="off"
                  :disabled="true"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="true"
                    @click="item.blinvoicedate = null"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <!-- :label="'BL Cost Total / Quoted ( ' + quotedrate + ' )'" -->
            <b-form-group
              :label="$helpers.requiredlabel(requirement, 'BL Cost Total')"
              :class="
                $helpers
                  .requiredlabel(requirement, 'BL Cost Total')
                  .slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-for="costtotal"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  size="sm"
                  id="date"
                  v-model="item.costtotal"
                  type="text"
                  placeholder="Enter BL cost"
                  autocomplete="off"
                  lazy-formatter
                  :formatter="nocomma"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="item.costtotal = null"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label="SL InvoiceNo"
              label-for="invoiceno"
              id="invoiceno"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.invoiceno"
                  placeholder="<auto assigned>"
                  size="sm"
                  :disabled="true"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="true"
                    @click="item.invoiceno = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <b-tooltip
                v-if="item.invoiceno"
                target="invoiceno"
                triggers="hover"
                >The current invoice number in the sales legder is
                {{ item.invoiceno }}</b-tooltip
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3" v-if="item.invoiceno">
            <b-form-group
              label-cols="12"
              label="SL Invoice No to Re-Invoice"
              label-size="sm"
              id="reinvoice"
            >
              <b-input-group>
                <b-form-input
                  v-model="reinvoice"
                  :placeholder="
                    item.invoiceno == null
                      ? '<auto assigned>'
                      : 'Enter Invoice No'
                  "
                  :state="
                    item.invoiceno == null || reinvoice == item.invoiceno
                      ? true
                      : false
                  "
                  :disabled="item.invoiceno == null"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="!reinvoice"
                    @click="reinvoice = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-tooltip target="reinvoice" triggers="hover"
              >Enter the existing invoice number to re-invoice the client with
              the new values, then select invoice to accounts</b-tooltip
            >
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              :label="$helpers.requiredlabel(requirement, 'Conf No')"
              :class="
                $helpers.requiredlabel(requirement, 'Conf No').slice(0, 1) ==
                '*'
                  ? 'text-danger'
                  : ''
              "
              label-for="confirmationno"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.confirmationno"
                  placeholder="Enter confirmation no"
                  size="sm"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.confirmationno = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Status" label-size="sm">
              <treeselect
                placeholder="Select status..."
                v-model="item.status"
                :clearable="false"
                :options="status_options"
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
                :disabled="readonly"
              >
                <!-- <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div> -->
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Agent" label-size="sm">
              <b-input-group>
                <b-form-input
                  v-model="item.agent"
                  placeholder="Agent"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="!item.agent"
                    @click="item.agent = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-2"
          ><b-col
            ><span class="text-danger small">* Required</span></b-col
          ></b-row
        >
      </b-card-body>

      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left" cols="4">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button
              squared
              size="sm"
              class="mr-1"
              variant="info"
              @click="saveit(true)"
              v-if="
                !item.invoiceno
                  ? true
                  : false || user.permissions.includes('cars.invoice')
              "
              :disabled="reinvoice != item.invoiceno"
            >
              <i class="fa fa-paper-plane"></i>
              Invoice to Accounts
            </b-button>
            <b-button
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
            <b-button
              size="sm"
              variant="primary"
              @click="saveit(false)"
              v-if="user.permissions.includes('save')"
            >
              <i class="fa fa-check"></i>
              Save It
            </b-button>
          </b-col>
          <!-- <b-col class="text-right" cols="8">
            <b-button
              squared
              size="sm"
              class="mr-1"
              variant="info"
              @click="save(true)"
              v-if="
                !item.invoiceno
                  ? true
                  : false || user.permissions.includes('carbookings.save')
              "
              :disabled="reinvoice != item.invoiceno"
            >
              <i class="fa fa-paper-plane"></i>
              Invoice to Accounts
            </b-button>
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
            <b-button
              squared
              size="sm"
              variant="primary"
              @click="save()"
              v-if="!item.invoiceno"
            >
              <i class="fa fa-check"></i>
              Save It
            </b-button>
          </b-col> -->
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

export default {
  name: "CarInvoiceEdit",
  props: ["search"],
  computed: {
    ...mapGetters(["user"]),
    readonly() {
      this.user.permissions.includes("cars.save") ? false : true;
      // if (
      //   this.user.rolename == "admin"
      // ) {
      //   return false;
      // } else {
      //   return this.item.invoiceno ? true : false;
      // }
    },
    quotedrate() {
      if (this.item.quotedrate) {
        return this.item.quotedrate;
      } else {
        return "N/A";
      }
    },
    status_options() {
      switch (this.item.status) {
        case "CX":
        case "AA":
        case "ST":
          return [
            { id: "ST", label: "New" },
            { id: "AA", label: "On Hold" },
            { id: "CX", label: "Cancelled" },
          ];
          break;
        case "ID":
          return [
            { id: "ID", label: "Invoiced" },
            { id: "CX", label: "Cancelled" },
          ];
          break;
      }
    },
  },
  watch: {
    item: {
      immediate: true,
      deep: true,
      async handler(newVal, oldVal) {
        console.log("watch:item", newVal);
        if (newVal) {
          if (newVal.items) {
            this.vatexcl = 0;
            for (var j = 0; j < newVal.items.length; ++j) {
              newVal.items[j].total =
                parseInt(newVal.items[j].qty) *
                parseFloat(newVal.items[j].cost);
              this.vatexcl += newVal.items[j].total;
            }
            this.totalvat = 0;
            this.total = this.vatexcl + this.totalvat;
          }
        }
      },
    },
    "item.slac": {
      // deep: true,
      // immediate: true,
      async handler(newVal, oldVal) {
        console.log("watch:item.slac", newVal);
        let attributes = await this.$helpers.loadSLACAttributes(newVal);
        console.log(attributes);
        if (attributes.includes(" / PO")) {
          this.$set(this.requirement, "yourref", "Your Ref / PO");
        } else {
          this.$delete(this.requirement, "yourref");
        }
        console.log(this.requirement);
      },
    },
  },
  data() {
    return {
      busy: false,
      message: "",
      requirement: {
        driver: "Driver",
        slac: "Client SL A/C",
        blac: "Supplier BL A/C",
        eventcode: "Event",
        yourref: "Your Ref / PO",
        blinvoiceno: "BL Invoice No",
        costtotal: "BL Cost Total",
        confirmationno: "Conf No",
      },
      item: {
        id: null,
        additionalcost1: "Time & Mileage",
        additionalcost2_value: null,
        additionalcost2: "Additional Insurances",
        additionalcost3_value: null,
        additionalcost3: "Upgrade",
        additionalcost4_value: null,
        additionalcost4: "Refueling",
        saleexvat: null,
        salevat: null,
        saletotal: null,
        message: null,
        yourref: null,
        invoiceno: null,
        agent: null,
        description: null,
      },
      vatexcl: 0,
      vat: 0,
      total: 0,
      reinvoice: null,
      options: {
        title: "Car Booking Edit",
        icon: "fa fa-car",
      },
    };
  },
  methods: {
    async load() {
      // this.busy = true;

      this.addRow();

      let variables = {
        id: this.idselected,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query carbookings($id: String) {
              carbookings(id: $id) {
                id
                driver
                slac
                eventcode
                confirmationno
                additionalcost1
                additionalcost1_value
                additionalcost2
                additionalcost2_value
                additionalcost3
                additionalcost3_value
                additionalcost4
                additionalcost4_value
                slinvoicedate
                yourref
                blac
                blinvoiceno
                blinvoicedate
                costtotal
                quotedrate
                invoiceno
                message
                status
                agent
                description
              }
            }
          `,
          variables,
        });
        console.log(response.data.carbookings);

        if (response.data.carbookings.length > 0) {
          this.item = response.data.carbookings[0];

          this.item.blinvoicedate = this.$helpers.datefield(
            this.item.blinvoicedate
          );
          this.item.slinvoicedate = this.$helpers.datefield(
            this.item.slinvoicedate
          );

          let items = [];
          for (var i = 1; i < 5; i++) {
            items.push({
              ref: this.item["additionalcost" + i],
              qty: 1,
              cost: this.item["additionalcost" + i + "_value"],
              taxes: 0,
              total: this.item["additionalcost" + i + "_value"],
            });
          }
          this.$set(this.item, "items", items);
        }
      } catch (error) {
        console.log(error);
      }
      // this.busy = false;
    },
    async saveit(invoice) {
      let row = { ...this.item };
      delete row.__typename;
      delete row._showDetails;
      delete row.id;

      this.message = this.$helpers.mandatoryFields(
        {
          driver: "Driver",
          slac: "Client SL A/C",
          blac: "Supplier BL A/C",
          eventcode: "Event",
          yourref: "Your Ref / PO",
          blinvoiceno: "BL Invoice No",
          costtotal: "BL Cost Total",
          confirmationno: "Conf No",
        },
        row
      );
      if (this.message.length > 0) {
        return;
      }

      if (row.slac == "BBC3") {
        if (!row.yourref) {
          this.message =
            "<span class='text-danger'>Your Ref/PO" + " is required!</span>";
          return;
        } else {
          let yrparts = row.yourref.split("*");
          console.log(yrparts, row.yourref);
          if (yrparts.length == 1) {
            this.message =
              "<span class='text-danger'>Your Ref/PO" +
              " needs a Booker Name (e.g. " +
              row.yourref +
              "*RE)</span>";
            return;
          }
        }
      }

      console.log(row.items);
      for (var i = 0; i < row.items.length; ++i) {
        row["additionalcost" + (i + 1)] = row.items[i]["ref"];
        row["additionalcost" + (i + 1) + "_value"] =
          row.items[i]["total"].toString();
      }
      delete row.items;

      row.saletotal = this.total.toString();
      if (row.status == "ID" && row.invoiceno) {
        row.status = "WI";
      }

      this.busy = true;

      let variables = {
        id: this.idselected,
        autocredit: this.autocredit,
        row,
      };

      if (invoice) {
        try {
          const response = await this.$apollo.mutate({
            mutation: gql`
              mutation invoicecar($id: String, $row: Carbooking_input) {
                invoicecar(id: $id, row: $row) {
                  id
                  driver
                  confirmationno
                  additionalcost1
                  additionalcost1_value
                  additionalcost2
                  additionalcost2_value
                  additionalcost3
                  additionalcost3_value
                  additionalcost4
                  additionalcost4_value
                  slac
                  slinvoicedate
                  yourref
                  blac
                  blinvoiceno
                  blinvoicedate
                  costtotal
                  invoiceno
                  message
                  status
                  agent
                  description
                }
              }
            `,
            variables,
          });
          if (response.data.invoicecar) {
            this.item = response.data.invoicecar;

            this.item.blinvoicedate = this.$helpers.datefield(
              this.item.blinvoicedate
            );
            this.item.slinvoicedate = this.$helpers.datefield(
              this.item.slinvoicedate
            );

            let items = [];
            for (var i = 1; i < 5; i++) {
              items.push({
                ref: this.item["additionalcost" + i],
                qty: 1,
                cost: this.item["additionalcost" + i + "_value"],
                taxes: 0,
                total: this.item["additionalcost" + i + "_value"],
              });
            }
            this.$set(this.item, "items", items);
            this.reinvoice = null;
          }
          this.message = "<span class='text-primary'>Invoiced it.</span>";
        } catch (error) {
          this.message =
            "<span class='text-danger error'>" + error.message + "</span>";
        }
      } else {
        try {
          const response = await this.$apollo.mutate({
            mutation: gql`
              mutation savecar($id: String, $row: Carbooking_input) {
                savecar(id: $id, row: $row) {
                  id
                }
              }
            `,
            variables,
          });
          this.message = "<span class='text-primary'>Saved it.</span>";

          this.$emit("refresh");
          this.$emit("discard", null);
        } catch (error) {
          this.message =
            "<span class='text-danger'>" + error.message + "</span>";
        }
      }
      this.busy = false;
    },
    discard() {
      this.$emit("refresh");
      this.$emit("discard", null);
    },
    addRow() {
      this.item = {
        id: null,
        additionalcost1: null,
        additionalcost2_value: null,
        additionalcost2: null,
        additionalcost3_value: null,
        additionalcost3: null,
        additionalcost4_value: null,
        additionalcost4: null,
        yourref: null,
        blinvoiceno: null,
        blinvoicedate: null,
        costtotal: null,
        invoiceno: null,
        message: null,
        status: null,
        agent: null,
        description: null,
      };
    },
    removeAt(idx) {
      this.item.items[idx].cost = "0.00";
      this.item.items[idx].total = "0.00";
    },
    addItemline() {
      //
    },
  },
};
</script>

<style>
.card {
  text-align: left !important;
}
</style>